// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Arfj","footer":"ModalInfo_footer__2ScKM"};